function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { createContext, useState, useEffect } from "react";
export const LocationContext = /*#__PURE__*/createContext();
export const LocationProvider = props => {
  const [geolocation, setGeolocation] = useState();
  useEffect(() => {
    fetch("https://api.ipstack.com/check?access_key=bf4730d1cb68c2da8872ac93fa7ec514").then(async res => {
      const result = await res.json();
      setGeolocation(result);
    });
  }, []);
  const value = {
    geolocation,
    setGeolocation
  };
  return /*#__PURE__*/React.createElement(LocationContext.Provider, _extends({
    value: value
  }, props));
};
export const LocationConsumer = LocationContext.Consumer;